import LottiePlayer from './components/lottie-player.vue';

window.vueMessages = new Vue({

	name: 'messages',

	el: '#messages-app',

	components: {

		LottiePlayer,

	},

	data: {

		messages: [],
		defaultMessagesToShow: 1,

	},

	computed: {

		messagesToShow() {

			if(this.messages.length > this.defaultMessagesToShow) {

				return this.defaultMessagesToShow;

			}
			else {

				return this.messages.length;

			}

		}

	},

    watch: {

        messages(message) {

            console.log('LC: messages updated', message);

        }

	},

	mounted() {

		// this.test();

	},

	methods: {

		contentClick(index) {

			if(coreHelpers.getNested(this, 'messages', index, 'url')) {

				window.location.href = this.messages[index].url;

			}
			else if(coreHelpers.getNested(this, 'messages', index, 'action')) {

				eval(this.messages[index].action)();
				this.dismiss(index);

			}

		},

		dismiss(index) {

			this.$delete(this.messages, index);

		},


		dismissAll() {

			this.messages = [];


		},

		addMessage(content, url = false, action = false, animationPath = false) {

			this.messages.push({

				'content': content,
				'url': url,
				'action': action, //this is a function callback
				'lottiePath': animationPath ? coreVariables.stylesheetUri + '/animation/' + animationPath + '.json' : false,
				'lottieName': animationPath ? animationPath : false,

			});

		},

		test() {

			this.addMessage('workout', false, false, 'workout')
			this.addMessage('cooking', false, false, 'cooking')
			this.addMessage('challenge-completed', false, false, 'challenge-completed')
			this.addMessage('goal-achieved', false, false, 'goal-achieved')
			this.addMessage('mindset', false, false, 'mindset')

		}
	}

});